import { render, staticRenderFns } from "./tcHeader.vue?vue&type=template&id=7bf4cc03&scoped=true&"
import script from "./tcHeader.vue?vue&type=script&lang=js&"
export * from "./tcHeader.vue?vue&type=script&lang=js&"
import style0 from "./tcHeader.vue?vue&type=style&index=0&id=7bf4cc03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf4cc03",
  null
  
)

export default component.exports